export default __webpack_public_path__ + "static/media/billing.f8d32519.svg";